module.exports = __webpack_public_path__ + "img/logo_oliveira_hospital.980f94c5.png";